import api from './base'

export default {
  /* return only opened orders per business unit */
  getAll ({ businessUnitId }) {
    return api().get(`company/business_units/${businessUnitId}/orders?type=0`)
  },
  getOpenedOrders ({ businessUnitId, table = null }) {
    let url = `company/business_units/${businessUnitId}/orders?type=1`
    if (table) {
      url += `&table=${table}`
    }
    return api().get(url)
  },
  getAllBetweenDates ({ businessUnitId, table = null, dateFrom, dateTo, dateEndFrom, dateEndTo, type }) {
    let url = `company/business_units/${businessUnitId}/orders?type=${type}`
    if (dateFrom) {
      url += `&dateFrom=${dateFrom}`
    }
    if (dateTo) {
      url += `&dateTo=${dateTo}`
    }
    if (dateEndFrom) {
      url += `&dateEndFrom=${dateEndFrom}`
    }
    if (dateEndTo) {
      url += `&dateEndTo=${dateEndTo}`
    }
    if (table) {
      url += `&table=${table}`
    }
    return api().get(url)
    // return api().get(`company/business_units/${businessUnitId}/orders?dateFrom=${dateFrom}&dateTo=${dateTo}&dateEndFrom=${dateEndFrom}&dateEndTo=${dateEndTo}&type=0`)
  },
  createOrder ({ electronicDeviceId, data }) {
    return api().put(`company/electronic_devices/${electronicDeviceId}/orders`, data)
  }
}
